import { type FC } from 'react';
import { HStack, Stub, type StubProps, VStack } from '@direct-frontend/components';

export interface CharacteristicItemStubProps {
    length: number;
    chipHeight: StubProps['height'];
    chipWidth: StubProps['width'];
    chipBorderRadius: StubProps['borderRadius'];
}

export const CharacteristicItemStub: FC<CharacteristicItemStubProps> = ({ length, chipWidth, chipHeight }) => (
    <VStack gap="12">
        <Stub height={18} width={100} />

        <HStack flexWrap="wrap" gap="8">
            {Array.from({ length }).map((_, index) => (
                <Stub key={index} height={chipHeight} width={chipWidth} borderRadius="8" />
            ))}
        </HStack>
    </VStack>
);
